import React from 'react';
import Page from '../../components/Page';
import { Users } from 'lucide-react';

const ClientsOverviewPage: React.FC = () => {
  return (
    <Page
      title="👥 Carteira de Clientes - Visão Geral"
      subtitle="Dashboard principal da Carteira de Clientes"
      onRefresh={() => window.location.reload()}
    >
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-center">
          <Users 
            className="h-16 w-16 mx-auto mb-4" 
            style={{ color: 'var(--primary)' }}
          />
          <h2 
            className="text-2xl font-semibold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            Carteira de Clientes - Em Desenvolvimento
          </h2>
          <p 
            style={{ color: 'var(--text-secondary)' }}
          >
            Esta página será implementada em breve
          </p>
        </div>
      </div>
    </Page>
  );
};

export default ClientsOverviewPage;
